/**
 * Dynamically adjusts the bottom margin of `.wp-block-cover` elements to ensure proper spacing.
 * It calculates the new margin based on the height of `.wp-block-cover__inner-container`.
 * This function runs on document load, window resize, and screen orientation change.
 */
function adjustOffsetCovers() {
  document.querySelectorAll(".offset-cover").forEach((offsetCover) => {
    const innerContainer = offsetCover.querySelector(
      ".wp-block-cover__inner-container",
    );
    if (innerContainer) {
      const height = innerContainer.offsetHeight / 2 + 50;
      const blockCover = offsetCover.querySelector(".wp-block-cover");
      if (blockCover) blockCover.style.marginBottom = `${height}px`;
    }
  });
}

// Run when document is ready.
document.addEventListener("DOMContentLoaded", adjustOffsetCovers);

// Run on window resize.
window.addEventListener("resize", adjustOffsetCovers);

// Run on screen orientation change.
screen.orientation.addEventListener("change", adjustOffsetCovers);
